import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

import { getProductPrice, getProductSpecialPrices } from '../../ProductActions';
import { getUserGroup, getUserGroupOption } from '../../../User/UserGroupActions';
import { getCartItemByProduct, getCartItemFromProduct, setCartItem } from '../../../Cart/CartActions';
import { getReferral } from '../../../App/AppActions';

import Price from '../../../Currency/components/view/Price';
import Icon from '../../../../components/Content/Icon';
import { getLoggedUser, getUserPreference } from '../../../User/UserActions';
import { formatPrice } from '../../../../util/price';

function ProductSpecialPriceQuantityInfo({ dispatch, product, item, user = null, userGroup = null, referral = null }) {
	const displayPriceHT = getUserGroupOption(userGroup, 'displayPriceHT');
	const productNormalPrice = getProductPrice(product, 1, userGroup, !displayPriceHT, referral);
	const specialPricseByQuantity = getProductSpecialPrices(product, displayPriceHT ? 'priceHT' : 'priceTTC', null, userGroup, referral).filter(specialPrice => specialPrice.quantity).reverse();

	const handleApplySpecialPriceQuantity = quantity => {
		if((item?.quantity || 0) < quantity) {
			dispatch(setCartItem(getCartItemFromProduct(product, quantity, getUserPreference(user), userGroup, { referral })));
		}
	};

	return specialPricseByQuantity.length > 0 && (
		<div className="text-success">
			{specialPricseByQuantity
				.filter(specialPrice => specialPrice.quantity > (item?.quantity || 1))
				.map(specialPrice => ({ ...specialPrice, unitSpecialPrice: getProductPrice(product, specialPrice.quantity, userGroup, !displayPriceHT, referral) / specialPrice.quantity }))
				.filter(specialPrice => specialPrice.value < productNormalPrice)
				.map(specialPrice => (
				<OverlayTrigger
					key={specialPrice.value}
					overlay={
						<Tooltip id={`${product.slug}-specialprice-${specialPrice.quantity}`}>
							<FormattedMessage id="productUnitPriceInclTax" defaultMessage="Unit price incl.tax" />: <Price amount={specialPrice.unitSpecialPrice} />
						</Tooltip>
					}
					placement="right"
				>
					<Button variant="link" as="span" key={specialPrice.quantity} className="d-block-inline m-0 p-0 text-success text-decoration-none" onClick={() => handleApplySpecialPriceQuantity(specialPrice.quantity)}>
						<Icon icon="chevron-right" />
						<FormattedMessage
							id="productSpecialPriceQuantityDiscount"
							defaultMessage="Buy {quantity} and save {percent}%!"
							values={{
								quantity: specialPrice.quantity,
								percent: Math.ceil(formatPrice(100 - ((specialPrice.unitSpecialPrice / productNormalPrice) * 100))),
							}}
						/>
					</Button>
				</OverlayTrigger>
			))}
		</div>
	);
}

ProductSpecialPriceQuantityInfo.propTypes = {
	dispatch: PropTypes.func.isRequired,
	product: PropTypes.object.isRequired,
	item: PropTypes.object,
	user: PropTypes.object,
	userGroup: PropTypes.object,
	referral: PropTypes.string,
};

const mapStateToProps = (store, props) => {
	return {
		item: getCartItemByProduct(store, props.product),
		user: getLoggedUser(store),
		userGroup: getUserGroup(store),
		referral: getReferral(store),
	};
};

export default connect(mapStateToProps)(ProductSpecialPriceQuantityInfo);
